<div class="row grid grid-cols-5 gap-4">
  <div class="p-4 grid grid-rows-2 gap-4 col-span-3">
    <div class="grid-cols-1">
      <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center">Carriles</div>
      <hr class="mb-2 dark:border-gray-500">

      <div class="bg-white dark:bg-gray-900/50 rounded-md w-full">
        <div class="p-2 overflow-x-auto">
          <div class="inline-block min-w-full shadow rounded-lg overflow-hidden">

            <table class="w-full">
              <thead>
                <tr
                  class="border-b-2 border-gray-200 dark:border-gray-600 bg-gray-100 dark:bg-gray-900/50 uppercase font-semibold text-xs text-center text-gray-600 dark:text-gray-300">
                  <th class="px-2 py-3">Caseta</th>
                  <th class="px-2 py-3">Carril</th>
                  <th class="px-2 py-3">Fondo</th>
                  <th class="px-2 py-3">Devolucion</th>
                  <th class="px-2 py-3">Retiro</th>
                  <th class="px-2 py-3">Morralla</th>
                  <th class="px-2 py-3">Rollo</th>
                </tr>
              </thead>

              <tbody *ngIf="notificaciones.length > 0; else noNotificaciones">

                <tr *ngFor="let notificacion of notificaciones; let i = index"
                  class="border-b border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-900/50 text-gray-900 dark:text-gray-300 text-sm text-center h-12">

                  <td class="p-2">
                    <p class="font-bold">{{ notificacion.caseta }}</p>
                  </td>

                  <td class="p-2">
                    <p class="font-bold">{{ notificacion.nombre }}</p>
                  </td>

                  <td class="p-2">
                    <p class="font-bold">${{ notificacion.fondo || 0 | number }}</p>
                  </td>

                  <td *ngFor="let nt of notificacion_tipo; let i = index" class="p-2">
                    <div *ngFor="let nn of notificacion.notificaciones">
                      <span *ngIf="nn.tipo_notificacion === nt.tipo && nn.estatus === 1" class="flex justify-center">
                        <svg routerLink="{{ nt.ruta }}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 19"
                          class="h-16 fill-yellow-500 cursor-pointer">
                          <g class="too-big-actually">
                            <g class="bell-whole">
                              <path class="bell-part bell-part--ringer"
                                d="M9.5,17.5a2,2,0,0,0,2-2h-4A2,2,0,0,0,9.5,17.5Z" />
                              <path class="bell-part bell-part--main"
                                d="M16.23,12.82c-.6-.65-1.73-1.62-1.73-4.82a4.93,4.93,0,0,0-4-4.85V2.5a1,1,0,0,0-2,0v.65A4.94,4.94,0,0,0,4.5,8c0,3.2-1.13,4.17-1.73,4.82a1,1,0,0,0-.27.68,1,1,0,0,0,1,1h12a1,1,0,0,0,1-1A1,1,0,0,0,16.23,12.82Z" />
                            </g>
                          </g>
                        </svg>
                      </span>
                    </div>
                  </td>

                </tr>

              </tbody>

              <ng-template #noNotificaciones>
                <tbody class="font-semibold text-sm">
                  <td colspan="7" class="py-4 text-center">
                    Sin informacion para este turno
                  </td>
                </tbody>
              </ng-template>

            </table>
          </div>
        </div>
      </div>

    </div>
    <div >
      <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center">FALLAS</div>
      <hr class="mb-2 dark:border-gray-500">

      <div class="bg-white dark:bg-gray-900/50 rounded-md w-full">
        <div class="p-2 overflow-x-auto">
          <div class="inline-block min-w-full shadow rounded-lg h-68 overflow-y-auto">

            <table class="w-full">
              <thead>
                <tr
                  class="border-b-2 border-gray-200 dark:border-gray-600 bg-gray-100 dark:bg-gray-900/50 uppercase font-semibold text-xs text-center text-gray-600 dark:text-gray-300">
                  <th class="px-2 py-3">Caseta</th>
                  <th class="px-2 py-3">Carril</th>
                  <th class="px-2 py-3">Falla</th>
                  <th class="px-2 py-3">Fecha y hora</th>
                </tr>
              </thead>

              <tbody *ngIf="fallas.length > 0; else noFallas">

                <tr (click)="confirmModal = true; saveTempFalla(falla)" *ngFor="let falla of fallas"
                  class="border-b border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-900/50 text-gray-900 dark:text-gray-300 text-sm text-center h-12 "
                  style="cursor: pointer;">
                  <td class="p-2">
                    <p class="font-bold">{{ falla.caseta }}</p>
                  </td>
                  <td class="p-2">
                    <p class="font-bold">{{ falla.carril }}</p>
                  </td>
                  <td class="p-2">
                    <p class="font-bold">{{ falla.falla }}</p>
                  </td>
                  <td class="p-2">
                    <p class="font-bold">{{ falla.fecha_hora }}</p>
                  </td>
                </tr>

              </tbody>

              <ng-template #noFallas>
                <tbody class="font-semibold text-sm">
                  <td colspan="4" class="py-4 text-center">
                    Sin fallas reportadas
                  </td>
                </tbody>
              </ng-template>

            </table>
          </div>
        </div>
      </div>

    </div>
  </div>
  <div class="p-4 grid col-span-2 gap-4 ">
    <div class=" grid grid-cols-1">
      <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center">Bitacora</div>
      <hr class="mb-2 dark:border-gray-500">
      <div class="bg-white dark:bg-gray-900/50 rounded-md grid-cols-1 p-2">
          <div class="inline-block min-w-full shadow rounded-lg overflow-hidden">

            <div class="grid grid-cols-2 gap-4">
              <div class="dark:text-white font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal text-center cursor-pointer"
                (click)="toggleTabs(1)" [ngClass]="{' bg-navy ': openTab !== 1, ' active bg-blue-600 ': openTab === 1}">Nuevo</div>
              <div class="dark:text-white font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal text-center cursor-pointer"
                  (click)="toggleTabs(2)" [ngClass]="{' bg-navy ': openTab !== 2, ' active bg-blue-600': openTab === 2}">Búsqueda</div>
            </div>
          </div>
          <div class="grid-cols-1 rounded">

                <div [ngClass]="{'hidden': openTab !== 1, 'block': openTab === 1}">

                  <form [formGroup]="formSaveBiatacora" class="estilo-dark dark:text-gray-100 bg-transparent grid grid-cols-1">

                      <label for="#convenio" class="estilo-dark text-center bg-transparent">Agregue su observación</label>
                      <textarea formControlName="observacion"
                        class="resize-y w-full text-sm p-2 font-semibold text-gray-500 bg-white dark:text-gray-100 dark:bg-gray-700  border border-solid border-gray-300 rounded m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                        rows="10" placeholder="Observaciones"></textarea>
                      <button (click)="saveBitacora()" type="button"
                            class="dark:bg-transparent estilo-dark dark:text-white">Guardar
                            bitacora</button>

                  </form>
                </div>
                <div [ngClass]="{'hidden': openTab !== 2, 'block': openTab === 2}">
                  <form [formGroup]="formBusquedaP" class="row">

                    <div class="estilo-dark dark:text-gray-100 dark:bg-transparent w-full">
                      <label for="#convenio" class="w-full estilo-dark dark:text-gray-100 dark:bg-transparent">Fecha</label>
                      <input formControlName="fecha" autocomplete="off" required
                        class="border rounded border-gray-300 placeholder-gray-500 px-3 py-2 block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-blue-400 focus:outline-none focus:ring-blue-500 focus:z-10 focus:shadow-outline-blue dark:text-gray-300 dark:focus:shadow-outline-gray h-12 form-input"
                        type="date" />
                    </div>
                    <div class=" estilo-dark dark:text-gray-100 dark:bg-transparent w-full">
                      <textarea formControlName="observacion"
                        class="resize-y w-full text-sm p-2 font-semibold uppercase text-gray-500 bg-white dark:text-gray-100 dark:bg-gray-700 bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                        rows="3" placeholder="Observaciones"></textarea>
                    </div>
                    <div class=" estilo-dark dark:text-gray-100 dark:bg-transparent w-full">
                      <button (click)="buscadorBitacora()"
                        class="w-3/4 dark:bg-transparent  drop-shadow-lg estilo-dark dark:text-white">
                        <!-- <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
                          stroke="currentColor" stroke-width="2">
                          <path stroke-linecap="round" stroke-linejoin="round"
                            d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4" />
                        </svg> -->
                          Buscar
                      </button>
                    </div>
                  </form>
                </div>

          </div>
      </div>
      <hr class="mb-2 dark:border-gray-500">


    </div>
    <div class="min-w-full shadow rounded-lg h-70 overflow-y-auto">

      <div class="p-2 overflow-x-auto ">

        <div *ngFor="let bitacora of bitacoras"
          class="flex bg-white dark:bg-gray-900/50 shadow-lg rounded-md text-xs text-gray-700 dark:text-gray-300 font-semibold mb-2">

          <div class="flex p-2 w-full">

            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24"
              stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z" />
            </svg>

            <div class="w-full">
              <div class="flex items-center justify-between text-lg">
                <p>{{bitacora.observacion}}</p>
              </div>

              <div class="flex justify-end mt-4">
                <div class="flex items-center mr-2">
                  <svg viewBox="0 0 24 24" fill="none" class="h-6 w-6" xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M20 10V7C20 5.89543 19.1046 5 18 5H6C4.89543 5 4 5.89543 4 7V10M20 10V19C20 20.1046 19.1046 21 18 21H6C4.89543 21 4 20.1046 4 19V10M20 10H4M8 3V7M16 3V7" stroke="#000000" stroke-width="2" stroke-linecap="round"></path> <rect x="6" y="12" width="3" height="3" rx="0.5" fill="#000000"></rect> <rect x="10.5" y="12" width="3" height="3" rx="0.5" fill="#000000"></rect> <rect x="15" y="12" width="3" height="3" rx="0.5" fill="#000000"></rect> </g></svg>
                  <span>{{bitacora.fecha_apertura}}</span>
                </div>
                <div class="flex items-center mr-2">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M5 19a2 2 0 01-2-2V7a2 2 0 012-2h4l2 2h4a2 2 0 012 2v1M5 19h14a2 2 0 002-2v-5a2 2 0 00-2-2H9a2 2 0 00-2 2v5a2 2 0 01-2 2z" />
                  </svg>
                  <span>{{bitacora.catBitacora.nombre}}</span>
                </div>

                <div class="flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                  </svg>
                  <span>{{bitacora.usuario.nombre}}</span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</div>
<div class="grid grid-flow-row-dense grid-cols-2 grid-rows-2 gap-4">

</div>

<div *ngIf="confirmModal" class="modal-component-container fixed inset-0 overflow-y-auto">
  <div
    class="modal-flex-container flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    <div class="modal-bg-container fixed inset-0 bg-gray-700 bg-opacity-75"></div>

    <div class="modal-space-container hidden sm:inline-block sm:align-middle sm:h-screen">&nbsp;</div>

    <div
      class="modal-container inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg w-full">
      <div class="modal-wrapper bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">

        <div class="modal-wrapper-flex sm:flex sm:items-start">

          <div class="modal-content mt-3 w-full sm:mt-0 sm:ml-0 sm:text-left space-y-3">

            <div class="flex items-center justify-between">
              <div class="flex items-center rounded py-2">
                <span class="pl-2">¿Estás seguro de atender la falla?</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-actions bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
        <button (click)="confirmModal = false"
          class="w-full inline-flex justify-center rounded-md border border-gray-300 shadow-md px-4 py-2  mt-3 bg-white font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-200 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
          Cerrar
        </button>
        <button (click)="atenderFalla()"
          class="w-full inline-flex justify-center rounded-md border border-gray-300 shadow-md px-4 py-2  mt-3 bg-white font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-200 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
          Aceptar
        </button>
      </div>

    </div>
  </div>
</div>
